import { baseApi } from '@/services/api';
import { Notification, NotificationPreferences } from './notificationsTypes';

export const notificationsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Notifications
    getNotifications: builder.query<Notification[], { read?: boolean; type?: string; limit?: number }>({
      query: (params) => ({
        url: '/notifications',
        method: 'GET',
        params,
      }),
      providesTags: ['Notifications'],
    }),
    
    getNotification: builder.query<Notification, string>({
      query: (id) => ({
        url: `/notifications/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Notifications', id }],
    }),
    
    markAsRead: builder.mutation<void, string>({
      query: (id) => ({
        url: `/notifications/${id}/read`,
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications'],
    }),
    
    markAllAsRead: builder.mutation<void, void>({
      query: () => ({
        url: '/notifications/read-all',
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications'],
    }),
    
    deleteNotification: builder.mutation<void, string>({
      query: (id) => ({
        url: `/notifications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
    
    getUnreadCount: builder.query<{ count: number }, void>({
      query: () => ({
        url: '/notifications/unread-count',
        method: 'GET',
      }),
      providesTags: ['Notifications'],
    }),
    
    // Notification Preferences
    getNotificationPreferences: builder.query<NotificationPreferences, void>({
      query: () => ({
        url: '/notifications/preferences',
        method: 'GET',
      }),
      providesTags: ['Notifications'],
    }),
    
    updateNotificationPreferences: builder.mutation<NotificationPreferences, Partial<NotificationPreferences>>({
      query: (preferences) => ({
        url: '/notifications/preferences',
        method: 'PUT',
        data: preferences,
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetNotificationQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
  useGetUnreadCountQuery,
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
} = notificationsAPI;
